<div class="register-buttons" (taxClickOutside)="showDropdown = false">
  <a
    class="like-button plus"
    data-qa-link="create-retail-place"
    routerLink="/main/kkms/add-retail-place"
  >
    {{ 'retail.place.add' | translate }}
  </a>
  <button
    *ngIf="hasRetailPlace"
    data-qa-button="create-kkm"
    class="kkm-register-button"
    (click)="showDropdown = !showDropdown"
  >
    {{ 'add.kkm.title' | translate }}
    <tax-icon name="arrow-down"></tax-icon>
  </button>
</div>
<!-- TODO сделать отдельной компонентой для переиспользования или реализовать в компоненте PageHeaderComponent возможность такого dropdown-->
<div *ngIf="showDropdown" class="kkm-register-dropdown">
  <a
    *ngFor="let item of kkmRegisterMethods"
    class="kkm-register-method"
    [attr.data-qa-link]="'kkm-register-method-' + item.name"
    (click)="goToRegisterProcess(item)"
  >
    <tax-icon [name]="item.icon"></tax-icon>
    <span
      class="kkm-register-method-title"
      [attr.data-qa]="'kkm-register-method-title-' + item.name"
      >{{ item.title | translate }}
    </span>
  </a>
</div>
